import { render, staticRenderFns } from "./thrash.vue?vue&type=template&id=7d0d46fc"
import script from "./thrash.vue?vue&type=script&lang=js"
export * from "./thrash.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports